import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {RouterService} from '../services/router.service';

export const rootLandingRedirectGuard: CanActivateFn = () => {
  inject(RouterService).navigateFromRoot();
  return false;
};
